import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import { saveToCache, loadFromCache } from './cache';
import { apiGet, apiGetWithHeader} from './services/service';

const langPath : string = ((window as any).langPath
? (window as any).langPath
: "en-US").toLowerCase();

//const langPath : string = ((window as any).location.pathname.split('/')[1]).toLowerCase();

const customBackend = {
    type: 'backend' as const,
    init: () => {},
  
    read: async (lng: string, _namespace: string, callback: (err: Error | null, data?: any) => void) => {
      const cachedData = loadFromCache(langPath);
      if (cachedData) {
        callback(null, cachedData);
        return;
      }

      try {
        
        const response = await apiGet(`/customerportal/localise/${langPath}`);
        if (!(response.status==200)) throw new Error('Failed to fetch translations');
  
        const translations = response.data;
  
        saveToCache(langPath, translations);
        callback(null, translations);
      } catch (error) {
        callback(error as Error, null);
      }
    },
  };

i18n
.use(initReactI18next)
.use(customBackend)
.init({
    interpolation: {
        escapeValue: false,
      },
    // backend: {
    //     loadPath: apiUrl+'build/locales/'+langPath+'/translation.json'
    //    },
})

  export default i18n;